.nord {
  --nord-night: #071017;
  --nord-ice: #dcebf0;
  --nord-white: #f4f6f3;
  --nord-blue: #7fd3ee;
  --nord-line: rgba(220, 235, 240, 0.22);
  color: var(--nord-white);
  background: var(--nord-night);
  font-family: "Outfit", sans-serif;
  overflow: clip;
}

/* Production pass: documentary route, live metrics and field evidence */
.nord {
  --nord-night: #111513;
  --nord-ice: #e7f0ec;
  --nord-white: #f4f7f3;
  --nord-blue: #c8ff36;
  --nord-line: rgba(231, 240, 236, 0.2);
  font-family: "IBM Plex Sans", sans-serif;
}

.nord h1,
.nord h2,
.nord-route__copy h3,
.nord-evidence__card h3 {
  font-family: "Newsreader", serif;
  font-weight: 500;
}

.nord-logo,
.nord-nav,
.nord-signal,
.nord-metrics,
.nord-route__aside,
.nord-route__copy > span,
.nord-route__copy > p:first-of-type,
.nord-route__visual > span,
.nord-evidence__content > p,
.nord-evidence__portrait > span,
.nord-evidence__card > span {
  font-family: "IBM Plex Mono", monospace;
}

.nord-progress__bar {
  background: var(--nord-blue);
}

.nord-pointer {
  width: 112px;
  height: 112px;
  color: var(--nord-blue);
  background:
    linear-gradient(90deg, transparent 49.5%, rgba(200, 255, 54, 0.4) 50%, transparent 50.5%),
    linear-gradient(transparent 49.5%, rgba(200, 255, 54, 0.4) 50%, transparent 50.5%);
  border-style: dashed;
  mix-blend-mode: screen;
}

.nord-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid var(--nord-line);
  border-bottom: 1px solid var(--nord-line);
}

.nord-metrics article {
  display: grid;
  gap: 28px;
  min-height: 230px;
  padding: clamp(24px, 3vw, 48px);
  border-right: 1px solid var(--nord-line);
}

.nord-metrics article:last-child {
  border-right: 0;
}

.nord-metrics strong {
  color: var(--nord-blue);
  font-size: clamp(2.7rem, 5vw, 6rem);
  font-weight: 500;
  letter-spacing: -0.07em;
  line-height: 0.86;
}

.nord-metrics span {
  align-self: end;
  max-width: 18ch;
  color: rgba(231, 240, 236, 0.65);
  font-size: 11px;
  letter-spacing: 0.08em;
  line-height: 1.5;
  text-transform: uppercase;
}

.nord-route {
  display: grid;
  grid-template-columns: minmax(300px, 0.42fr) minmax(0, 1fr);
  gap: clamp(34px, 6vw, 110px);
  padding: clamp(90px, 12vw, 190px) clamp(20px, 5vw, 78px);
  background:
    linear-gradient(rgba(200, 255, 54, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(200, 255, 54, 0.035) 1px, transparent 1px),
    #0a0e0c;
  background-size: 48px 48px;
}

.nord-route__aside {
  position: sticky;
  top: 90px;
  align-self: start;
  display: grid;
  gap: 24px;
  min-height: calc(100vh - 150px);
}

.nord-route__aside > p,
.nord-route__aside > span {
  margin: 0;
  color: var(--nord-blue);
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.nord-route__aside h2 {
  max-width: 9ch;
  margin: 0;
  font-size: clamp(3rem, 5vw, 6.4rem);
  line-height: 0.9;
  letter-spacing: -0.055em;
}

.nord-route__aside > span {
  align-self: end;
  color: rgba(231, 240, 236, 0.52);
}

.nord-route__radar {
  position: relative;
  display: grid;
  place-items: center;
  width: clamp(150px, 18vw, 260px);
  aspect-ratio: 1;
  color: var(--nord-blue);
  border: 1px solid rgba(200, 255, 54, 0.35);
  border-radius: 50%;
  background:
    radial-gradient(circle, transparent 33%, rgba(200, 255, 54, 0.14) 34%, transparent 35%, transparent 65%, rgba(200, 255, 54, 0.14) 66%, transparent 67%);
}

.nord-route__radar::before,
.nord-route__radar::after {
  position: absolute;
  content: "";
  background: rgba(200, 255, 54, 0.28);
}

.nord-route__radar::before {
  width: 100%;
  height: 1px;
}

.nord-route__radar::after {
  width: 1px;
  height: 100%;
}

.nord-route__radar i {
  position: absolute;
  inset: 7%;
  border-top: 1px solid var(--nord-blue);
  border-radius: 50%;
}

.nord-route__radar svg {
  width: 30%;
  height: 30%;
  stroke-width: 1;
}

.nord-route__chapters {
  display: grid;
  gap: clamp(100px, 15vw, 230px);
}

.nord-route__chapter {
  display: grid;
  grid-template-columns: minmax(0, 1.16fr) minmax(260px, 0.84fr);
  gap: clamp(24px, 4vw, 64px);
  align-items: end;
}

.nord-route__chapter:nth-child(even) .nord-route__visual {
  order: 2;
}

.nord-route__visual {
  position: relative;
  overflow: hidden;
  aspect-ratio: 4 / 5;
  background: #1b211e;
}

.nord-route__chapter:nth-child(3n + 1) .nord-route__visual {
  aspect-ratio: 4 / 3;
}

.nord-route__visual::after {
  position: absolute;
  inset: 0;
  content: "";
  background: linear-gradient(180deg, transparent 55%, rgba(5, 8, 6, 0.68));
  pointer-events: none;
}

.nord-route__visual img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: saturate(0.82) contrast(1.05);
  transition: transform 900ms cubic-bezier(0.16, 1, 0.3, 1), filter 500ms ease;
}

.nord-route__chapter:hover .nord-route__visual img {
  transform: scale(1.035);
  filter: saturate(1) contrast(1.02);
}

.nord-route__visual > span {
  position: absolute;
  z-index: 2;
  right: 18px;
  bottom: 16px;
  left: 18px;
  color: var(--nord-white);
  font-size: 9px;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}

.nord-route__copy {
  display: grid;
  gap: 16px;
  padding-bottom: 6px;
}

.nord-route__copy > span {
  color: var(--nord-blue);
  font-size: clamp(2.8rem, 5vw, 6rem);
  line-height: 0.8;
}

.nord-route__copy > p:first-of-type {
  margin: 12px 0 0;
  color: var(--nord-blue);
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.nord-route__copy h3 {
  margin: 0;
  font-size: clamp(2rem, 3.3vw, 4rem);
  line-height: 0.95;
  letter-spacing: -0.04em;
}

.nord-route__copy > p:last-child {
  max-width: 47ch;
  margin: 0;
  color: rgba(231, 240, 236, 0.67);
  font-size: 15px;
  line-height: 1.65;
}

.nord-evidence {
  display: grid;
  grid-template-columns: minmax(280px, 0.72fr) minmax(0, 1.28fr);
  min-height: 900px;
  color: #111513;
  background: var(--nord-ice);
}

.nord-evidence__portrait {
  position: relative;
  overflow: hidden;
  min-height: 760px;
}

.nord-evidence__portrait::after {
  position: absolute;
  inset: 0;
  content: "";
  background: linear-gradient(180deg, transparent 60%, rgba(0, 0, 0, 0.64));
}

.nord-evidence__portrait img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nord-evidence__portrait > span {
  position: absolute;
  z-index: 2;
  right: 24px;
  bottom: 22px;
  left: 24px;
  color: #fff;
  font-size: 9px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.nord-evidence__content {
  padding: clamp(55px, 8vw, 130px) clamp(24px, 6vw, 90px);
}

.nord-evidence__content > p {
  margin: 0 0 28px;
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.nord-evidence__content > h2 {
  max-width: 10ch;
  margin: 0 0 clamp(60px, 8vw, 120px);
  font-size: clamp(3.2rem, 6vw, 7.5rem);
  line-height: 0.86;
  letter-spacing: -0.055em;
}

.nord-evidence__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid rgba(17, 21, 19, 0.28);
}

.nord-evidence__card {
  display: grid;
  align-content: start;
  gap: 22px;
  min-height: 320px;
  padding: 24px 22px 10px 0;
  border-right: 1px solid rgba(17, 21, 19, 0.22);
}

.nord-evidence__card + .nord-evidence__card {
  padding-left: 22px;
}

.nord-evidence__card:last-child {
  border-right: 0;
}

.nord-evidence__card > span {
  color: #5e6c64;
  font-size: 9px;
}

.nord-evidence__card h3 {
  margin: 0;
  font-size: clamp(1.45rem, 2vw, 2.3rem);
  line-height: 1;
}

.nord-evidence__card p {
  margin: 0;
  color: #536059;
  font-size: 14px;
  line-height: 1.6;
}

@media (max-width: 1000px) {
  .nord-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .nord-metrics article:nth-child(2) {
    border-right: 0;
  }

  .nord-metrics article:nth-child(-n + 2) {
    border-bottom: 1px solid var(--nord-line);
  }

  .nord-route {
    grid-template-columns: 1fr;
  }

  .nord-route__aside {
    position: relative;
    top: auto;
    grid-template-columns: 1fr auto;
    min-height: 0;
  }

  .nord-route__aside > span {
    display: none;
  }

  .nord-route__radar {
    grid-column: 2;
    grid-row: 1 / 3;
  }

  .nord-route__chapter {
    grid-template-columns: minmax(0, 1.1fr) minmax(240px, 0.9fr);
  }

  .nord-evidence {
    grid-template-columns: 1fr;
  }

  .nord-evidence__portrait {
    min-height: 70vh;
  }
}

@media (max-width: 680px) {
  .nord-metrics article {
    min-height: 170px;
    padding: 22px 18px;
  }

  .nord-route {
    padding-inline: 18px;
  }

  .nord-route__aside {
    display: grid;
    grid-template-columns: 1fr;
  }

  .nord-route__radar {
    grid-column: auto;
    grid-row: auto;
    width: 140px;
  }

  .nord-route__chapter,
  .nord-route__chapter:nth-child(even) {
    grid-template-columns: 1fr;
  }

  .nord-route__chapter:nth-child(even) .nord-route__visual {
    order: 0;
  }

  .nord-route__visual,
  .nord-route__chapter:nth-child(3n + 1) .nord-route__visual {
    aspect-ratio: 4 / 5;
  }

  .nord-evidence__content {
    padding-inline: 20px;
  }

  .nord-evidence__grid {
    grid-template-columns: 1fr;
  }

  .nord-evidence__card,
  .nord-evidence__card + .nord-evidence__card {
    min-height: 0;
    padding: 24px 0;
    border-right: 0;
    border-bottom: 1px solid rgba(17, 21, 19, 0.22);
  }
}

.nord-progress {
  position: fixed;
  z-index: 1200;
  top: 0;
  right: 0;
  left: 0;
  height: 3px;
  pointer-events: none;
}

.nord-progress__bar {
  display: block;
  width: 100%;
  height: 100%;
  background: var(--nord-blue);
  transform: scaleX(0);
  transform-origin: left;
}

.nord-nav {
  position: absolute;
  z-index: 30;
  top: 0;
  right: 0;
  left: 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  min-height: 88px;
  padding: 0 clamp(20px, 4vw, 70px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.nord-logo {
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.nord-logo span {
  color: var(--nord-blue);
  font-weight: 400;
}

.nord-nav nav {
  display: flex;
  gap: 32px;
  font-family: "Roboto Mono", monospace;
  font-size: 10px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.nord-nav a {
  min-height: 44px;
}

.nord-nav__cta {
  display: inline-flex;
  align-items: center;
  justify-self: end;
  gap: 10px;
  padding: 0 16px;
  color: var(--nord-night);
  background: var(--nord-white);
  font-family: "Roboto Mono", monospace;
  font-size: 10px;
  text-transform: uppercase;
}

.nord-nav__cta svg {
  width: 15px;
}

.nord-hero {
  position: relative;
  display: grid;
  min-height: max(780px, 100svh);
  overflow: hidden;
}

.nord-hero__frame,
.nord-hero__veil {
  position: absolute;
  inset: 0;
}

.nord-hero__frame {
  overflow: hidden;
  will-change: clip-path;
}

.nord-hero__image {
  width: 100%;
  height: 112%;
  object-fit: cover;
  object-position: center 38%;
  will-change: transform;
}

.nord-hero__veil {
  background:
    linear-gradient(90deg, rgba(3, 10, 15, 0.8), rgba(3, 10, 15, 0.12) 55%, rgba(3, 10, 15, 0.35)),
    linear-gradient(180deg, rgba(3, 10, 15, 0.22), rgba(3, 10, 15, 0.1) 58%, rgba(3, 10, 15, 0.78));
}

.nord-hero__copy {
  position: relative;
  z-index: 3;
  align-self: end;
  padding: 150px clamp(20px, 5vw, 84px) clamp(64px, 8vw, 118px);
}

.nord-hero__eyebrow,
.nord-manifesto > p,
.nord-fieldwork__copy > p:first-child,
.nord-readiness__heading > p,
.nord-apply__copy > p:first-child {
  margin: 0 0 24px;
  font-family: "Roboto Mono", monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.nord-hero__title {
  max-width: 1100px;
  margin: 0;
  font-size: clamp(5rem, 14vw, 13.5rem);
  font-weight: 600;
  line-height: 0.69;
  letter-spacing: -0.085em;
  text-transform: uppercase;
}

.nord-hero__title span {
  display: block;
}

.nord-hero__title span:last-child {
  margin-left: 0.62em;
  color: transparent;
  -webkit-text-stroke: 1.5px rgba(255, 255, 255, 0.88);
}

.nord-hero__actions {
  display: grid;
  grid-template-columns: minmax(280px, 540px) auto;
  gap: 42px;
  align-items: end;
  margin-top: 48px;
  margin-left: min(22vw, 310px);
}

.nord-hero__actions p {
  margin: 0;
  color: #d5dee1;
  font-size: clamp(1rem, 1.45vw, 1.25rem);
  line-height: 1.55;
}

.nord-hero__actions a {
  display: inline-flex;
  align-items: center;
  gap: 18px;
  min-height: 58px;
  padding: 0 22px;
  color: var(--nord-night);
  background: var(--nord-blue);
  font-family: "Roboto Mono", monospace;
  font-size: 11px;
  text-transform: uppercase;
}

.nord-hero__actions svg {
  width: 17px;
  transition: transform 220ms ease;
}

.nord-hero__actions a:hover svg {
  transform: translateX(5px);
}

.nord-hero__aside {
  position: absolute;
  z-index: 3;
  right: clamp(20px, 4vw, 70px);
  bottom: 36px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 5px 24px;
  width: 260px;
  padding-top: 16px;
  font-family: "Roboto Mono", monospace;
  font-size: 9px;
  text-transform: uppercase;
  border-top: 1px solid rgba(255, 255, 255, 0.4);
}

.nord-hero__aside span {
  opacity: 0.58;
}

.nord-hero__aside b {
  font-weight: 500;
}

.nord-hero__aside svg {
  grid-row: 1 / 3;
  grid-column: 2;
  width: 18px;
}

.nord-signal {
  display: grid;
  grid-template-columns: repeat(3, 1fr) 1.25fr;
  border-bottom: 1px solid var(--nord-line);
}

.nord-signal > div,
.nord-signal > p {
  min-height: 150px;
  padding: 28px clamp(18px, 3vw, 44px);
  border-right: 1px solid var(--nord-line);
}

.nord-signal > div {
  display: grid;
  grid-template-columns: auto 1fr;
  align-content: center;
  gap: 5px 14px;
}

.nord-signal svg {
  grid-row: 1 / 3;
  width: 20px;
  color: var(--nord-blue);
}

.nord-signal span,
.nord-signal > p {
  color: #8f9da2;
  font-family: "Roboto Mono", monospace;
  font-size: 9px;
  line-height: 1.6;
  text-transform: uppercase;
}

.nord-signal b {
  font-size: clamp(1.2rem, 2vw, 2rem);
  font-weight: 500;
}

.nord-signal > p {
  display: grid;
  align-content: center;
  margin: 0;
  border-right: 0;
}

.nord-manifesto {
  padding: clamp(104px, 12vw, 188px) clamp(20px, 5vw, 84px) clamp(124px, 14vw, 218px);
}

.nord-manifesto > p {
  color: var(--nord-blue);
}

.nord-manifesto h2 {
  max-width: 1500px;
  margin: 0;
  font-size: clamp(3.6rem, 8.3vw, 10rem);
  font-weight: 500;
  line-height: 0.87;
  letter-spacing: -0.065em;
}

.nord-manifesto__line {
  display: block;
  overflow: hidden;
}

.nord-manifesto__line > span {
  display: block;
}

.nord-manifesto__note {
  display: grid;
  grid-template-columns: 100px minmax(280px, 560px);
  gap: 30px;
  margin: 80px 0 0 auto;
  width: min(100%, 760px);
}

.nord-manifesto__note span {
  color: var(--nord-blue);
  font-family: "Roboto Mono", monospace;
  font-size: 10px;
}

.nord-manifesto__note p {
  margin: 0;
  color: #aab6ba;
  font-size: 18px;
  line-height: 1.65;
}

.nord-story {
  position: relative;
  overflow: hidden;
  background: var(--nord-ice);
}

.nord-story__track {
  display: flex;
  width: max-content;
  min-height: 100svh;
}

.nord-story article {
  flex: 0 0 100vw;
  min-height: 100svh;
}

.nord-story__cover {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: clamp(90px, 9vw, 150px) clamp(20px, 6vw, 100px);
  color: var(--nord-night);
}

.nord-story__cover p,
.nord-story__copy > span,
.nord-story__copy > p:first-of-type,
.nord-story__visual > span {
  font-family: "Roboto Mono", monospace;
  font-size: 10px;
  text-transform: uppercase;
}

.nord-story__cover h2 {
  max-width: 950px;
  margin: 20px 0 0;
  font-size: clamp(4rem, 9vw, 10rem);
  line-height: 0.82;
  letter-spacing: -0.075em;
}

.nord-story__cover svg {
  width: min(24vw, 300px);
  height: auto;
  stroke-width: 0.55;
}

.nord-story__chapter {
  display: grid;
  grid-template-columns: 1.08fr 0.92fr;
  color: var(--nord-white);
  background: #0a151d;
  border-left: 1px solid rgba(255, 255, 255, 0.18);
}

.nord-story__visual {
  position: relative;
  overflow: hidden;
  margin: 26px;
}

.nord-story__visual::after {
  position: absolute;
  inset: 0;
  content: "";
  background: linear-gradient(180deg, transparent 60%, rgba(3, 10, 15, 0.64));
}

.nord-story__visual img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nord-story__visual > span {
  position: absolute;
  z-index: 2;
  bottom: 24px;
  left: 24px;
}

.nord-story__copy {
  display: grid;
  align-content: center;
  padding: clamp(46px, 7vw, 110px);
}

.nord-story__copy > span {
  color: var(--nord-blue);
}

.nord-story__copy > p:first-of-type {
  margin: 70px 0 20px;
  color: #829097;
}

.nord-story__copy h3 {
  max-width: 740px;
  margin: 0;
  font-size: clamp(3.5rem, 6vw, 7.5rem);
  font-weight: 500;
  line-height: 0.84;
  letter-spacing: -0.065em;
}

.nord-story__copy > p:last-child {
  max-width: 48ch;
  margin: 36px 0 0;
  color: #aab6ba;
  font-size: 17px;
  line-height: 1.65;
}

.nord-fieldwork {
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  min-height: 930px;
  color: var(--nord-night);
  background: var(--nord-white);
}

.nord-fieldwork__image {
  position: relative;
  overflow: hidden;
  min-height: 760px;
}

.nord-fieldwork__image img {
  width: 100%;
  height: 110%;
  object-fit: cover;
}

.nord-fieldwork__image span {
  position: absolute;
  bottom: 24px;
  left: 24px;
  padding: 10px 12px;
  color: var(--nord-white);
  background: var(--nord-night);
  font-family: "Roboto Mono", monospace;
  font-size: 9px;
  text-transform: uppercase;
}

.nord-fieldwork__copy {
  align-self: center;
  padding: clamp(60px, 8vw, 130px);
}

.nord-fieldwork__copy h2,
.nord-readiness__heading h2,
.nord-apply h2 {
  margin: 0;
  font-size: clamp(3.4rem, 6vw, 7rem);
  font-weight: 500;
  line-height: 0.87;
  letter-spacing: -0.065em;
}

.nord-fieldwork__copy > p:nth-of-type(2) {
  margin: 38px 0 0;
  color: #4d5a60;
  font-size: 18px;
  line-height: 1.65;
}

.nord-fieldwork ul {
  display: grid;
  gap: 0;
  margin: 44px 0 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid #bbc4c7;
}

.nord-fieldwork li {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 0;
  border-bottom: 1px solid #bbc4c7;
  font-size: 14px;
}

.nord-fieldwork li svg {
  width: 18px;
  color: #177a9b;
}

.nord-readiness {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: clamp(110px, 15vw, 220px) clamp(20px, 5vw, 84px);
}

.nord-readiness__heading {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 0.32fr 0.68fr;
  gap: 40px;
  padding-bottom: 90px;
}

.nord-readiness article {
  min-height: 430px;
  padding: 30px;
  border: 1px solid var(--nord-line);
}

.nord-readiness article + article {
  border-left: 0;
}

.nord-readiness article span {
  color: var(--nord-blue);
  font-family: "Roboto Mono", monospace;
  font-size: 10px;
}

.nord-readiness article h3 {
  margin: 170px 0 0;
  font-size: clamp(2rem, 3vw, 3.6rem);
  font-weight: 500;
  letter-spacing: -0.045em;
}

.nord-readiness article p {
  max-width: 36ch;
  margin: 20px 0 0;
  color: #91a0a6;
  line-height: 1.6;
}

.nord-apply {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(60px, 10vw, 170px);
  padding: clamp(88px, 10vw, 156px) clamp(20px, 6vw, 100px) clamp(104px, 12vw, 184px);
  color: var(--nord-night);
  background: var(--nord-blue);
}

.nord-apply__copy > p:last-child {
  max-width: 50ch;
  margin: 36px 0 0;
  font-size: 17px;
  line-height: 1.65;
}

.nord-apply .demo-form input {
  border-color: rgba(7, 16, 23, 0.5);
}

.nord-apply .demo-form__submit {
  color: var(--nord-white);
  background: var(--nord-night);
}

.nord-footer {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 30px;
  align-items: center;
  min-height: 150px;
  padding: 30px clamp(20px, 4vw, 70px) 70px;
  color: #91a0a6;
  font-family: "Roboto Mono", monospace;
  font-size: 10px;
  text-transform: uppercase;
}

.nord-footer p {
  margin: 0;
}

.nord-footer > a:last-child {
  justify-self: end;
}

@media (max-width: 900px) {
  .nord-nav {
    grid-template-columns: 1fr auto;
  }

  .nord-nav nav {
    display: none;
  }

  .nord-hero__actions {
    grid-template-columns: 1fr;
    margin-left: 0;
  }

  .nord-hero__actions a {
    width: max-content;
  }

  .nord-hero__aside {
    display: none;
  }

  .nord-signal {
    grid-template-columns: repeat(2, 1fr);
  }

  .nord-story {
    overflow: visible;
  }

  .nord-story__track {
    display: block;
    width: auto;
  }

  .nord-story article {
    min-height: auto;
  }

  .nord-story__cover {
    min-height: 82svh !important;
  }

  .nord-story__chapter,
  .nord-fieldwork,
  .nord-apply {
    grid-template-columns: 1fr;
  }

  .nord-story__chapter {
    width: 100%;
    padding: 18px;
    overflow: hidden;
  }

  .nord-story__chapter > *,
  .nord-story__copy {
    min-width: 0;
    max-width: 100%;
  }

  .nord-story__visual {
    min-height: 70svh;
    margin: 0;
  }

  .nord-story__copy {
    min-height: 680px;
  }

  .nord-readiness {
    grid-template-columns: 1fr;
  }

  .nord-readiness__heading {
    grid-template-columns: 1fr;
  }

  .nord-readiness article + article {
    border-top: 0;
    border-left: 1px solid var(--nord-line);
  }
}

@media (max-width: 600px) {
  .nord-nav {
    min-height: 70px;
    padding-inline: 16px;
  }

  .nord-nav__cta {
    padding-inline: 11px;
    font-size: 8px;
  }

  .nord-hero {
    min-height: 900px;
  }

  .nord-hero__copy {
    padding-inline: 18px;
  }

  .nord-hero__title {
    font-size: clamp(4.5rem, 23vw, 7rem);
  }

  .nord-hero__title span:last-child {
    margin-left: 0;
  }

  .nord-signal {
    grid-template-columns: 1fr;
  }

  .nord-signal > div,
  .nord-signal > p {
    border-right: 0;
    border-bottom: 1px solid var(--nord-line);
  }

  .nord-manifesto {
    padding-inline: 18px;
  }

  .nord-manifesto__note {
    grid-template-columns: 1fr;
  }

  .nord-story__cover {
    align-items: flex-start;
    flex-direction: column;
  }

  .nord-story__cover svg {
    width: 55vw;
  }

  .nord-story__copy {
    min-height: 600px;
    padding-inline: 22px;
  }

  .nord-fieldwork__copy,
  .nord-readiness,
  .nord-apply {
    padding-inline: 20px;
  }

  .nord-footer {
    grid-template-columns: 1fr;
  }

  .nord-footer > a:last-child {
    justify-self: start;
  }
}

/* Final polish: coordinate field, topographic atmosphere and local light */
.nord h1,
.nord h2,
.nord-route__copy h3,
.nord-evidence__card h3 {
  font-family: "Prata", Georgia, serif;
  font-weight: 400;
}

.nord-coordinate-field {
  z-index: 2;
  opacity: 0.72;
  mix-blend-mode: screen;
  -webkit-mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.88), transparent 82%);
  mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.88), transparent 82%);
}

.nord-hero__veil {
  z-index: 1;
}

.nord-nav__cta,
.nord-hero__actions a {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(200, 255, 54, 0.65);
  box-shadow: 0 0 0 rgba(200, 255, 54, 0);
  transition: color 350ms ease, background 350ms ease, box-shadow 350ms ease;
}

.nord-nav__cta::after,
.nord-hero__actions a::after {
  position: absolute;
  inset: -2px;
  pointer-events: none;
  content: "";
  background: linear-gradient(110deg, transparent 20%, rgba(255, 255, 255, 0.55) 48%, transparent 76%);
  transform: translateX(-130%);
  transition: transform 750ms cubic-bezier(0.16, 1, 0.3, 1);
}

.nord-nav__cta:hover,
.nord-hero__actions a:hover {
  background: #d9ff70;
  box-shadow: 0 0 28px rgba(200, 255, 54, 0.3), 0 16px 45px rgba(0, 0, 0, 0.2);
}

.nord-nav__cta:hover::after,
.nord-hero__actions a:hover::after {
  transform: translateX(130%);
}

.nord-manifesto {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  background:
    repeating-radial-gradient(ellipse at 84% 48%, transparent 0 34px, rgba(200, 255, 54, 0.055) 35px 36px, transparent 37px 68px),
    linear-gradient(135deg, #111513 0%, #0c1310 100%);
}

.nord-manifesto::before {
  position: absolute;
  z-index: -1;
  right: -0.08em;
  bottom: -0.18em;
  content: "79°N";
  color: rgba(231, 240, 236, 0.028);
  font-family: "IBM Plex Mono", monospace;
  font-size: clamp(10rem, 32vw, 38rem);
  font-weight: 600;
  line-height: 0.72;
  letter-spacing: -0.11em;
  white-space: nowrap;
}

.nord-route__chapter {
  --spot-color: rgba(200, 255, 54, 0.12);
  padding: clamp(18px, 2vw, 30px);
  margin: clamp(-30px, -2vw, -18px);
  border: 1px solid transparent;
  transition: border-color 650ms ease, background 650ms ease, box-shadow 650ms ease;
}

.nord-route__chapter:hover {
  background: rgba(231, 240, 236, 0.018);
  border-color: rgba(200, 255, 54, 0.14);
  box-shadow: 0 36px 90px rgba(0, 0, 0, 0.22);
}

.nord-evidence {
  position: relative;
  background:
    linear-gradient(rgba(7, 16, 23, 0.045) 1px, transparent 1px),
    linear-gradient(90deg, rgba(7, 16, 23, 0.045) 1px, transparent 1px),
    var(--nord-ice);
  background-size: 64px 64px;
}

.nord-evidence__card {
  --spot-color: rgba(23, 122, 155, 0.13);
  transition: transform 500ms cubic-bezier(0.16, 1, 0.3, 1), background 500ms ease;
}

.nord-evidence__card:hover {
  z-index: 2;
  background: rgba(255, 255, 255, 0.35);
  transform: translateY(-8px);
}

.nord-readiness article {
  background:
    linear-gradient(145deg, rgba(200, 255, 54, 0.035), transparent 52%),
    rgba(255, 255, 255, 0.008);
  transition: transform 550ms cubic-bezier(0.16, 1, 0.3, 1), border-color 550ms ease, box-shadow 550ms ease;
}

.nord-readiness article:hover {
  border-color: rgba(200, 255, 54, 0.42);
  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.24), inset 0 0 42px rgba(200, 255, 54, 0.035);
  transform: translateY(-10px);
}

@media (max-width: 700px) {
  .nord-coordinate-field {
    opacity: 0.42;
  }
}

/* QA pass: readable telemetry, compact cards and serif-safe headings */
.nord-signal {
  grid-template-columns: repeat(3, minmax(0, 1fr)) minmax(300px, 1.35fr);
}

.nord-signal span {
  font-size: 10px;
}

.nord-signal > p {
  font-size: 13px;
  line-height: 1.55;
  letter-spacing: 0.02em;
  text-transform: none;
}

.nord-metrics article {
  align-content: space-between;
  gap: 34px;
  min-height: 188px;
  position: relative;
  overflow: hidden;
  transition: background 500ms ease, transform 500ms cubic-bezier(0.16, 1, 0.3, 1);
}

.nord-metrics article::after {
  position: absolute;
  inset: 0;
  pointer-events: none;
  content: "";
  background: linear-gradient(112deg, transparent 34%, rgba(200, 255, 54, 0.09) 49%, transparent 64%);
  transform: translateX(-115%);
  transition: transform 850ms cubic-bezier(0.16, 1, 0.3, 1);
}

.nord-metrics article:hover {
  background: rgba(200, 255, 54, 0.035);
  transform: translateY(-6px);
}

.nord-metrics article:hover::after {
  transform: translateX(115%);
}

.nord-metrics strong span {
  display: inline-block;
  max-width: none;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  text-transform: none;
  white-space: nowrap;
}

.nord-metrics article > span {
  align-self: end;
  max-width: 22ch;
  color: rgba(231, 240, 236, 0.72);
  font-family: "Roboto Mono", monospace;
  font-size: 11px;
  line-height: 1.6;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.nord-metrics strong {
  min-width: 0;
  font-size: clamp(2.55rem, 4.35vw, 5.15rem);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.nord .nord-apply .demo-form.demo-form--dark .demo-form__submit {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: min(100%, 360px);
  height: 62px;
  min-height: 62px;
  max-height: 62px;
  padding: 0 22px;
  color: #e7f0ec;
  background:
    linear-gradient(90deg, rgba(194, 255, 0, 0.08), transparent 48%),
    #071017;
  border: 1px solid rgba(7, 16, 23, 0.92);
  box-shadow: 8px 8px 0 rgba(7, 16, 23, 0.16);
  font-family: "Roboto Mono", monospace;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  transition: color 220ms ease, background-color 220ms ease, box-shadow 220ms ease, transform 220ms ease;
}

.nord .nord-apply .demo-form {
  align-self: start;
  align-content: start;
}

.nord .nord-apply .demo-form.demo-form--dark .demo-form__submit::after {
  content: "↗";
  font-size: 20px;
  font-weight: 400;
}

.nord .nord-apply .demo-form.demo-form--dark .demo-form__submit:hover {
  color: #071017;
  background: #e7f0ec;
  box-shadow: 4px 4px 0 rgba(7, 16, 23, 0.26);
  transform: translate(4px, 4px);
}

.nord-evidence__content > h2 {
  max-width: 11ch;
  font-size: clamp(3rem, 5.4vw, 6.7rem);
  line-height: 0.98;
}

.nord-fieldwork__copy h2,
.nord-readiness__heading h2,
.nord-apply h2 {
  font-size: clamp(3.1rem, 5.45vw, 6.4rem);
  line-height: 0.98;
}

.nord-readiness {
  padding-block: clamp(76px, 9vw, 125px);
}

.nord-readiness__heading {
  padding-bottom: 48px;
}

.nord-readiness article {
  min-height: 285px;
}

.nord-readiness article h3 {
  margin-top: 56px;
}

@media (max-width: 1100px) {
  .nord-signal {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .nord-signal > p {
    min-height: 118px;
  }
}

@media (max-width: 700px) {
  .nord-signal {
    grid-template-columns: 1fr;
  }

  .nord-readiness article {
    min-height: 270px;
  }

  .nord-readiness article h3 {
    margin-top: 58px;
  }
}
